import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    queryRoles: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/roles`,
        isArray: true
    },
    queryRentalOwners: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalOwners/list`,
        isArray: true
    },
    getRentalOwner: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners/:id`
    },
    updateUserAccount: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/:id/account`
    },
    toggleUserAccountAccess: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/:id/access`
    },
    resetUserPassword: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/:id/password`
    },
    getSmsHistory: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/:id/sms/history`,
        params: {
            '$orderby': 'Id desc',
            '$count': true
        }
    },
    getSmsHistoryV3: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/users/:id/sms/history`,
        params: {
            '$count': true
        }
    },
    getAiSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/:id/sms/aiSummary`
    },
    queryLookUpStaffMembers: {
        method: 'GET',
        url: `${BASE_PATH_API}/staffMembers/lookup`,
        isArray: true
    },
    queryStaffMembers: {
        method: 'GET',
        url: `${BASE_PATH_API}/staffMembers`,
        isArray: true
    },
    updatePassword: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/updatePassword`
    },
    updateEmail: {
        method: 'PUT',
        url: `${BASE_PATH_API}/users/updateEmail`
    },
    isUserPrimaryContact: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/isUserPrimaryContact/:id`
    },
    getUserUsedInformation: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/:id/usages`
    },
    getUserDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/:id`
    },
    getActingUserAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/account`,
        isArray: true
    },
    getEmailUniquenessValidation: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/:id/emails/isUnique`
    },
    shouldSuggestTwoFactorAuthentication: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/twoFactorAuthentication/isRequired`
    },
    getRentalOwners: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/rentalOwners`,
        params: {
            '$count': true
        },
        isArray: true
    },
    getStaffMembers: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/staff`,
        params: {
            '$count': true
        },
        isArray: true
    },
    getVendors: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/vendors`,
        params: {
            '$count': true
        },
        isArray: true
    },
    doesUserHasBuildingAccess: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/building/:buildingId/access`
    },
    getUserVoiceUrl: {
        method: 'GET',
        url: `${BASE_PATH_API}/userVoice/userVoiceUrl`
    },
    createAPIUser: {
        method: 'POST',
        url: `${BASE_PATH_API}/apiManagement/users`
    },
    getCurrentUser: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/self`
    },
    getCurrentUserProfilePhoto: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/self/profilePhoto`
    }
};

export function UsersApi(
    $httpParamSerializer
) {
    const service = createActions(actions);
    service.getTwoFactorAuthUsersExportUrl = function getTwoFactorAuthUsersExportUrl(params) {
        return `${BASE_PATH_API}/users/twoFactorAuthUsers/export?${$httpParamSerializer(params)}`;
    };

    service.getStaffMembersExportUrl = function getStaffMembersExportUrl(params) {
        return `${BASE_PATH_API}/users/staff/export?${$httpParamSerializer(params)}`;
    };

    service.getVendorsExportUrl = function getVendorsExportUrl(params) {
        return `${BASE_PATH_API}/users/vendors/export?${$httpParamSerializer(params)}`;
    };

    service.getRentalOwnersExportUrl = function getRentalOwnersExportUrl(params) {
        return `${BASE_PATH_API}/users/rentalOwners/export?${$httpParamSerializer(params)}`;
    };
    return service;
}
UsersApi.$inject = [
    '$httpParamSerializer'
];
